import * as yup from 'yup';

const BankAccountFormSchema = yup.object().shape({
  routing_number: yup.string()
    .required('Enter routing number')
    .matches(/^[0-9]*$/g, 'Routing number is invalid')
    .length(9, 'Routing number must be 9 digits'),
  account_number: yup.string()
    .required('Enter account number')
    .matches(/^[a-zA-Z0-9]*$/g, 'Account number is invalid')
});

export default BankAccountFormSchema;
